// meta
export const socketIsConnectedSelector = state => state.meta && state.meta.socket && state.meta.socket.isConnected ? state.meta.socket.isConnected : false;
export const getIsMessageBlocked = state => state.meta.isMessageBlocked;
export const getIsPhoneAuthRequestFailed = state => state.meta.auth.isPhoneAuthRequestFailed;
export const getCarBrands = state => state.meta.carBrands;
export const getOrders = state => state.meta.orders;
export const getIsAuthModalOpened = state => state.meta.auth.isAuthModalOpen;
export const getIsLogoutModalOpened = state => state.meta.auth.isLogoutModalOpen;
export const getIsAuthCodeValid = state => state.meta.auth.isAuthCodeValid;
export const getAuthCodeErrorMessage = state => state.meta.auth.authCodeErrorMessage;
export const getUserNewOrderCount = state => state.meta.userNewOrderCount;

export const getSenderId = state => state.meta.user.senderId;
export const getVisitorId = state => state.meta.user.visitorId;
export const getBuyerId = state => state.meta.user.id;
export const getIsUserAuthenticated = state => !!state.meta.user?.id;
export const getPhoneNumber = state => state.meta.user.phoneNumber;
export const getIsKeyboardOpen = state => state.meta.isKeyboardOpen;
export const getSelectedPvz = state => state.meta.selectedPvz;
export const getCurrentMobileLayout = state => state.meta.currentMobileLayout;
export const getIsArchiveDialogFixed = state => state.meta.isArchiveDialogFixed;

// environment
export const getIsEmex = state => state.environment.isEmex;
export const getIsTestingEnv = state => state.environment.isTestingEnv;
export const getIsDevEnv = state => state.environment.isDevEnv;
export const getIsLocalEnv = state => state.environment.isLocalhostEnv;
export const getIsMobile = state => state.environment.isMobile;
export const getIsBigTabletAndDesktop = state => state.environment.isBigTablet;


// dialogs
export const getDialogsState = state => state.dialogs;
export const getDialogsItems = state => state.dialogs.dialogs;
export const getCurrentDialogId = state => state.dialogs?.currentDialogId || state.meta.user.dialogId;
export const getExpertChanged = state => state.dialogs?.expertChanged;
export const getIsDialogStatusChanged = state => state.dialogs.isDialogStatusChanged;
export const getIsCurrentDialogArchive = state => state.dialogs.isArchiveDialog;
export const getUnreadDialogsCount = state => state.dialogs?.dialogsCount?.filter(dialog => dialog.unread_count !== 0);

// messages
export const getIsTyping = state => state.messages.isTyping;
export const getMessageButtons = state => state.messages.buttons;
export const getMessagesItems = state => state.messages.items;
export const getSavedMessages = state => state.messages.savedItems;
export const getIsOutcomingLast = state => state.messages.isOutcomingLast;
export const getIsMessageLoading = state => state.messages.isLoading;
export const getHasMessageHistory = state => state.messages.hasHistory;
export const getImagePreview = state => state.messages.imagePreview;

// experts
export const getActiveExpert = state => state.experts.activeExpert;
export const getTypingExperts = state => state.experts.typingExperts;
export const getExpertsOnlineStatus = state => state.experts.onlineExperts;
export const getChangeExpertReasons = state => state.experts.changeExpertReasons;
export const getIsNewExpertButtonDisabled = state => state.experts.isNewExpertButtonDisabled;
export const getExpertsList = state => state.experts.list;
export const getExpertMode = state => state.experts.mode;

// modals
export const getMenuModalShow = state => state.menuModal.isShow;
export const getIsMenuModalSearchActive = state => state.menuModal.isSearchActive;
export const getMenuModalSearchQuery = state => state.menuModal.searchQuery;

export const getImageModalShow = state => state.imageModal.isShow;
export const getImageModalItems = state => state.imageModal.items;
export const getImageModalCurrentImage = state => state.imageModal.currentImage;
